import { useState } from "react";
import { createPortal } from "react-dom";
import { BoxArrowRight, XCircle, CheckCircle } from "react-bootstrap-icons";
import { useAuth } from "../contexts/AuthContext";

function LogoutButton({ closeMenu }) {
  const { logout, loggingOut } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    if (closeMenu) closeMenu();
    setShowModal(true);
  };

  const confirmLogout = async () => {
    await logout();
    setShowModal(false);
  };

  const cancelLogout = () => setShowModal(false);

  return (
    <>
      {/* Main logout button */}
      <button
        onClick={handleClick}
        disabled={loggingOut}
        className={`logout-btn btn btn-outline-danger d-flex align-items-center gap-2 ${
          loggingOut ? "disabled" : ""
        }`}
      >
        {loggingOut ? (
          <>
            <BoxArrowRight /> Logging out...
          </>
        ) : (
          <>
            <BoxArrowRight /> Logout
          </>
        )}
      </button>

      {showModal &&
        createPortal(
          <>
            {/* Backdrop */}
            <div
              className="modal-backdrop fade show"
              style={{ zIndex: 1040 }}
              onClick={cancelLogout}
            />

            {/* Modal */}
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              role="dialog"
              style={{ zIndex: 1050 }}
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title d-flex align-items-center gap-2">
                      <BoxArrowRight /> Confirm Logout
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={cancelLogout}
                    />
                  </div>
                  <div className="modal-body">
                    <p>Are you sure you want to log out?</p>
                  </div>
                  <div className="modal-footer d-flex gap-2">
                    <button
                      type="button"
                      className="btn btn-secondary d-flex align-items-center gap-2"
                      onClick={cancelLogout}
                    >
                      <XCircle /> Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-danger d-flex align-items-center gap-2"
                      onClick={confirmLogout}
                      disabled={loggingOut}
                    >
                      <CheckCircle /> {loggingOut ? "Logging out…" : "Logout"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </>,
          document.body,
        )}
    </>
  );
}

export default LogoutButton;
